import { z } from "zod";
import { apiClient } from "../client";
import { createTagRequestSchema, tagSchema, updateTagRequestSchema } from "./schemas";
import type { CreateTagRequest, Tag, UpdateTagRequest } from "./types";

export async function getTags(): Promise<Tag[]> {
  const response = await apiClient.get("tags", {}).json<Tag[]>();

  return z.array(tagSchema).parse(response);
}

export async function createTag(data: CreateTagRequest): Promise<Tag> {
  const parsed = createTagRequestSchema.parse(data);

  const response = await apiClient.post("tags", { json: parsed }).json<Tag>();

  return tagSchema.parse(response);
}

export async function getTag(id: string | number): Promise<Tag> {
  const response = await apiClient.get(`tags/${id}`, {}).json<Tag>();

  return tagSchema.parse(response);
}

export async function updateTag(
  id: string | number,
  data: UpdateTagRequest
): Promise<Tag> {
  const parsed = updateTagRequestSchema.parse(data);

  const response = await apiClient
    .put(`tags/${id}`, { json: parsed })
    .json<Tag>();

  return tagSchema.parse(response);
}

export async function deleteTag(id: string | number): Promise<void> {
  await apiClient.delete(`tags/${id}`, {});
}


